import React from "react";
import { MainModal } from "../../../../components/modal/MainModal";
import useUploadXlsx from "../../../../hooks/useUploadXlsx";
import { api } from "../api";

export const Upload = ({ onClose }) => {
  const { error, file, onFileUpload, request } = useUploadXlsx(api.importRevenueCategories);

  const primaryBtnHandler = () => {
    request();
    onClose();
  };

  return (
    <>
      <MainModal
        isOpen
        onClose={onClose}
        parentSelector=".revenue-categories"
        primaryButtonText="Upload"
        primaryBtnHandler={primaryBtnHandler}
        primaryButtonDisabled={!file}
        secondaryBtnText="Cancel"
        secondaryBtnHandler={onClose}
        width={650}
        height="auto"
        headerCloseHandler={onClose}
        headerText="Import Pricing Options"
      >
        <input type="file" accept=".xlsx" placeholder="Choose XLSX file" onChange={onFileUpload} />

        {error && <div className="help-block">* {error}</div>}
      </MainModal>
    </>
  );
};
